import React, {useEffect, useState} from "react";
import IconActive from "../../../assets/images/eoro-2024/icon-active-skins-red.svg";
import TopThreePositions from "../../EuroLeaderBoard/TopThreePositions";
import Position from "../../EuroLeaderBoard/Position";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {GAME_LEADERBOARD, OVER_ALL_LEADERBOARD, STAGING_BASE_URL} from "../../../Axios/EndPoints";
import {get} from "../../../Axios/get";
import SmallLoader from "../../SmallLoader";
import ButtonLoader from "../../ButtonLoader";

const Leaderboard = (props) => {
    const {
        isMobile,
        leagueMatchDays,
        leagueId,
    } = props;

    const { tab, id ,matchDayId} = useParams();
    // console.log("tab is >>>", tab, " and id is >>>>", id, " and matchDayId is >>>", matchDayId)
    const navigate = useNavigate();

    const [params] = useSearchParams();
    const user = useSelector(state => state?.Login);

    const [initialLoading, setInitialLoading] = useState(false);
    const [paginationLoading, setPaginationLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(id === "overall" ? 0 : (id === "game-wise" ? 1 : 0));
    // console.log("activeTab >>>", activeTab);

    const [isGameWise, setIsGameWise] = useState(false);

    // console.log("isGameWise >>>", isGameWise)

    const initialActiveMatchDay = leagueMatchDays?.find(matchDay => matchDay?.is_active);
    const [selectedMatchDay, setSelectedMatchDay] = useState(matchDayId || initialActiveMatchDay?.id);
    // console.log("selectedMatchDay >>>>", initialActiveMatchDay);
    const [leaderBordData, setLeaderBoardData] = useState(null);
    // console.log("leaderBordData >>>", leaderBordData)

    const [overallPage, setOverallPage] = useState(1);
    const [gameWisePage, setGameWisePage] = useState(1);
    const limit = 10;

    const [hasMoreOverallData, setHasMoreOverallData] = useState(true);
    const [hasMoreGameWiseData, setHasMoreGameWiseData] = useState(true);

    useEffect(() => {
        if (activeTab === 0) {
            fetchOverAllLeaderBoard(overallPage);
        } else if (activeTab === 1) {
            if (selectedMatchDay){
                fetchGameWiseLeaderBoard(gameWisePage);
            }
        }
    }, [activeTab, overallPage, gameWisePage]);

    useEffect(() => {
        if (activeTab === 1) {
            if(selectedMatchDay){
                setGameWisePage(1); // Reset page number when match day changes
                fetchGameWiseLeaderBoard(1);
            }
        }
    }, [selectedMatchDay]);

    const fetchOverAllLeaderBoard = (page) =>{
        let token = user?.user?.token;
        let isStaging = parseInt(params.get('staging'));
        page === 1 && setInitialLoading(true);
        let endpoint = OVER_ALL_LEADERBOARD
        endpoint = endpoint.replace('__LEAGUE_ID__', leagueId);

        get(
            endpoint + `?page=${page}&limit=${limit}`,
            true,
            token,
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            const newData = res?.data?.data;
            // console.log("reposne for fetching over all leaderBoard >>>", res?.data?.data)
            // setLeaderBoardData(res?.data?.data)
            if (newData?.leaderboard?.length < limit) {
                setHasMoreOverallData(false);
            }

            if (page === 1) {
                setLeaderBoardData(newData);
            } else {
                setLeaderBoardData(prevData => ({
                    ...prevData,
                    // top_positions: prevData?.top_positions?.concat(newData?.top_positions),
                    leaderboard: prevData?.leaderboard?.concat(newData?.leaderboard)
                }));
            }
            setInitialLoading(false);
            setPaginationLoading(false);
        }).catch(error => {
            console.error("Error while fetching over all leaderBoard :", error);
            setInitialLoading(false);
            setPaginationLoading(false);
        })
    }
    const fetchGameWiseLeaderBoard = (page) =>{
        setIsGameWise(true);
        let token = user?.user?.token;
        let isStaging = parseInt(params.get('staging'));
        page === 1 && setInitialLoading(true);
        let endpoint = GAME_LEADERBOARD
        endpoint = endpoint.replace('__MATCH_DAY_ID__', selectedMatchDay);

        get(
            endpoint + `?page=${page}&limit=${limit}`,
            true,
            token,
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            const newData = res?.data?.data;
            // console.log("reposne for fetching Game wise leaderBoard >>>", res?.data?.data)
            // setLeaderBoardData(res?.data?.data);
            if (newData?.leaderboard?.length < limit) {
                setHasMoreGameWiseData(false);
            }
            if (page === 1) {
                setLeaderBoardData(newData);
            } else {
                setLeaderBoardData(prevData => ({
                    ...prevData,
                    // top_positions: prevData?.top_positions?.concat(newData?.top_positions),
                    leaderboard: prevData?.leaderboard?.concat(newData?.leaderboard)
                }));
            }
            setInitialLoading(false);
            setPaginationLoading(false);
        }).catch(error => {
            console.error("Error while fetching game wise leaderBoard :", error);
            setInitialLoading(false);
            setPaginationLoading(false);
        })
    }


    const handleTabClick = (index) => {
        if (index === 0){
            navigate(`/euro-24/leaderboard/overall`);
            setOverallPage(1);
            setHasMoreOverallData(true);
        }
        if(index === 1){
            navigate(`/euro-24/leaderboard/game-wise/${selectedMatchDay || initialActiveMatchDay?.id}`);
            setGameWisePage(1);
            setHasMoreGameWiseData(true);
        }
        setActiveTab(index);
    };

    const onClickMatchDay = (matchDayId) => {
        setSelectedMatchDay(matchDayId);
        navigate(`/euro-24/leaderboard/game-wise/${matchDayId}`);
    };

    const loadMore = () => {
        setPaginationLoading(true);
        if (activeTab === 0) {
            setOverallPage(prevPage => prevPage + 1);
        } else if (activeTab === 1) {
            setGameWisePage(prevPage => prevPage + 1);
        }
    }

    const renderLeaderBoard = () =>{
        return(
            <>
                <div className={"d-flex align-items-center flex-column w-100 justify-content-center"}>
                    {
                        leaderBordData?.top_positions?.length > 0 &&
                        <>
                            <div className={`d-flex align-items-center ${isMobile ? "w-100":"w-50"}`}>
                                <TopThreePositions
                                    isMobile={isMobile}
                                    topPositions = {leaderBordData?.top_positions || []}
                                    isGameWise={isGameWise}
                                    selectedMatchDay={selectedMatchDay}
                                />
                            </div>
                        </>
                    }

                    <div className={"d-flex align-items-center w-100"}>
                        <Position
                            isMobile={isMobile}
                            user={leaderBordData?.user || null}
                            leaderboard={leaderBordData?.leaderboard || []}
                            isGameWise={isGameWise}
                            selectedMatchDay={selectedMatchDay}
                        />
                    </div>

                    {((activeTab === 0 && hasMoreOverallData) || (activeTab === 1 && hasMoreGameWiseData)) && (
                        <button onClick={loadMore} disabled={paginationLoading} className={`bg-transparent border-0 fw-700 cabin font-18  ${isMobile ? "text-skins-red":"text-skins-red"}`}>
                            {paginationLoading ? <><ButtonLoader loading={paginationLoading}/></> : "Load More"}
                        </button>
                    )}
                </div>
            </>
        )
    }

    const renderMobile = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-end gap-3 px-3"}>
                    <div className={"d-flex flex-row align-items-center gap-2"} role={"button"}>
                        {
                            activeTab === 0 &&
                            <img
                                src={IconActive}
                                alt={"icon-active"}
                                height={10}
                                width={10}
                            />
                        }
                        <div className={`fw-700 cabin font-18 ${activeTab === 0 ? 'text-skins-red' : ''}`}
                             onClick={(e) => {
                                 e.preventDefault();
                                 setIsGameWise(false);
                                 handleTabClick(0);
                             }}
                        >Overall Game
                        </div>
                    </div>
                    <div className="vertical-line-tabs-teal"/>
                    <div className={"d-flex flex-row align-items-center gap-2"} role={"button"}>
                        {
                            activeTab === 1 &&
                            <>
                                <img
                                    src={IconActive}
                                    alt={"icon-active"}
                                    height={10}
                                    width={10}
                                />
                            </>
                        }
                        <div className={`fw-700 cabin font-18 ${activeTab === 1 ? 'text-skins-red' : ''}`}
                             onClick={(e) => {
                                 e.preventDefault();
                                 setIsGameWise(true);
                                 handleTabClick(1);
                             }}
                        >By Game
                        </div>
                    </div>
                </div>
                <div className={"mt-3 mx-2"}>
                    {
                        activeTab === 0 &&
                        <>
                            {
                                initialLoading ?
                                    <>
                                        <SmallLoader loading={initialLoading}/>
                                    </>
                                    :
                                    <>
                                        {renderLeaderBoard()}
                                    </>
                            }
                        </>
                    }
                    {
                        activeTab === 1 &&
                        <>

                            <div className={"d-flex flex-row align-items-center justify-content-between gap-2"}>
                                {leagueMatchDays?.map((matchDay, index) => (
                                    <div
                                        key={index}
                                        role={"button"}
                                        className={`px-3 py-1 w-fit rounded fw-300 font-14 cabin text-center ${
                                            ((selectedMatchDay === matchDay?.id) || (matchDay?.id === parseInt(matchDayId))) ? 'bg-green text-white ' : 'bg-white'
                                        }`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onClickMatchDay(matchDay?.id);
                                        }}
                                    >
                                        {matchDay?.name}
                                    </div>
                                ))}
                            </div>
                            {
                                initialLoading ?
                                    <>
                                        <SmallLoader loading={initialLoading}/>
                                    </>
                                    :
                                    <>
                                        {renderLeaderBoard()}
                                    </>
                            }
                        </>
                    }
                </div>


            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-end gap-3"}>
                    <div className={"d-flex flex-row align-items-center gap-2"} role={"button"}>
                        {
                            activeTab === 0 &&
                            <img
                                src={IconActive}
                                alt={"icon-active"}
                                height={10}
                                width={10}
                            />
                        }
                        <div className={`fw-700 cabin font-18 ${activeTab === 0 ? 'text-skins-red' : 'text-white'}`}
                             onClick={(e) => {
                                 e.preventDefault();
                                 setIsGameWise(false)
                                 handleTabClick(0);
                             }}
                        >Overall Game
                        </div>
                    </div>
                    <div className="vertical-line-tabs-teal"/>
                    <div className={"d-flex flex-row align-items-center gap-2"} role={"button"}>
                        {
                            activeTab === 1 &&
                            <>
                                <img
                                    src={IconActive}
                                    alt={"icon-active"}
                                    height={10}
                                    width={10}
                                />
                            </>
                        }
                        <div className={`fw-700 cabin font-18 ${activeTab === 1 ? 'text-skins-red' : 'text-white'}`}
                             onClick={(e) => {
                                 e.preventDefault();
                                 setIsGameWise(true)
                                 handleTabClick(1);
                             }}>By Game
                        </div>
                    </div>
                </div>
                <div className={"mt-3"}>
                    {
                        activeTab === 0 &&
                        <>
                            {
                                initialLoading ?
                                    <>
                                        <SmallLoader loading={initialLoading}/>
                                    </>
                                    :
                                    <>
                                        {renderLeaderBoard()}
                                    </>
                            }
                        </>
                    }
                    {
                        activeTab === 1 &&
                        <>
                            <div className={"d-flex flex-row align-items-center justify-content-between gap-3 my-4"}>
                                {leagueMatchDays?.map((matchDay, index) => (
                                    <div
                                        key={index}
                                        role={"button"}
                                        className={`px-5 py-2 w-fit rounded fw-500 font-25 cabin ${
                                            ((selectedMatchDay === matchDay?.id) || (matchDay?.id === parseInt(matchDayId))) ? 'bg-green text-white' : 'bg-white'
                                        }`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onClickMatchDay(matchDay?.id, matchDay);
                                        }}
                                    >
                                        <div className={"mx-5"}>
                                            {matchDay?.name}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {
                                initialLoading ?
                                    <>
                                        <SmallLoader loading={initialLoading}/>
                                    </>
                                    :
                                    <>
                                        {renderLeaderBoard()}
                                    </>
                            }
                        </>
                    }
                </div>

            </>
        );
    }
    const render = () => {
        return (
            <section className={"px-2"}>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default Leaderboard;
